<template>
  <DatePicker
    v-model="date"
    :disabled="disabled"
    :clearable="clearable"
    :size="size"
    :start-placeholder="startPlaceholder"
    :end-placeholder="endPlaceholder"
    type="daterange"
    :range-separator="rangeSeparator"
    :picker-options="pickerOptions"
    @change="handleChange"
  />
</template>

<script>
import { DatePicker } from 'element-ui';
import moment from 'moment';

import shortcuts from '@/config/shortcuts';

export default {
  components: {
    DatePicker,
  },

  model: {
    prop: 'value',
    event: 'change',
  },

  props: {
    value: {
      type: Array,
      required: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: 'large',
    },

    startPlaceholder: {
      type: String,
      default: '开始日期',
    },

    endPlaceholder: {
      type: String,
      default: '结束日期',
    },

    rangeSeparator: {
      type: String,
      default: '-',
    },

    disabledDate: {
      type: Function,
      default(time) {
        return (
          time.getTime() >=
          moment()
            .subtract(1, 'day')
            .valueOf()
        );
      },
    },
  },

  data() {
    return {
      date: this.value,
      pickerOptions: {
        disabledDate: this.disabledDate,
        shortcuts: this.getShortCuts(),
      },
    };
  },

  watch: {
    value(newVal) {
      this.date = newVal;
    },
  },

  methods: {
    getShortCuts() {
      const arr = [];
      // eslint-disable-next-line guard-for-in
      for (let key in shortcuts) {
        const date = shortcuts[key];
        const shortcut = {
          text: date.text,
          onClick(picker) {
            picker.$emit('pick', date.data);
          },
        };
        arr.push(shortcut);
      }
      return arr;
    },

    handleChange() {
      const [startDate, endDate] = this.date;
      this.$emit('change', [moment(startDate), moment(endDate)]);
    },
  },
};
</script>
